import React, { useContext } from 'react'
import ReactDOM from 'react-dom'

import DataContext from '../../contexts/data.jsx'

import DeliveryField from './Field.jsx'

const DeliveryFields = ({ delivery, setData }) => {
    const data = useContext(DataContext),
    checkRelation = (property) => {
        if (!(property.PROPS_GROUP_ID === 2 || property.PROPS_GROUP_ID === 4)) {
            return false
        }

        if (!property.RELATIONS) return false

        if (!property.RELATIONS.DELIVERY) return false

        if (property.RELATIONS.DELIVERY.length > 0) {
            if (property.RELATIONS.DELIVERY.indexOf(data.delivery.id) === -1) {
                return false
            }
        } else {
            return false
        }

        if (property.PERSON_TYPE_ID != data.contacts.person) {
            return false
        }

        return true
    },
    handleChange = (property, e) => {
        const newContextData = Object.assign({}, data)

        const propertyGroup = data.data._properties[data.data._propertiesList[property.ID].PROPS_GROUP_ID],
        field = newContextData.contacts.fields[propertyGroup.ID][property.CODE],
        value = e.target.value

        field.value = value

        try {
            if (field.REQUIRED === false && value === '') {
                field.isErrors = false
            } else {
                const regExp = field.SETTINGS.PATTERN ? new RegExp(field.SETTINGS.PATTERN) : null
                
                if (regExp) {
                    field.isErrors = !regExp.test(value)
                }
            }
        } catch(e) {
            
        }
        
        setData(newContextData)
    }

    return <div className="happy-order__delivery-fields">{ data.data.propertiesList.map((property) => {
        if (checkRelation(property)) {
            const propertyGroup = data.data._properties[data.data._propertiesList[property.ID].PROPS_GROUP_ID],
            field = data.contacts.fields[propertyGroup.ID][property.CODE]

            return <DeliveryField
                key={ `delivery-field-${ property.ID }` }
                property={ property }
                field={ field }
                handleChange={ handleChange }
            />
        } else {
            return null
        }
    }) }</div>
}

export default DeliveryFields